import { render } from "./ServiceDetails2Page.vue?vue&type=template&id=9c59686a&ts=true"
import script from "./ServiceDetails2Page.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails2Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__